export const faqs = [
  {
    q: "What is MentorX4u?",
    a: "MentorX4u is a comprehensive platform designed to provide AI-driven counseling services for education and career guidance. We aim to empower users with personalized insights and resources to help them navigate their educational and professional journeys."
  },
  {
    q: "How does MentorX4u protect my personal information?",
    a: "At MentorX4u, we take data protection seriously. We implement robust security measures to safeguard your personal information, adhere to applicable data protection laws, and maintain a transparent Privacy Policy."
  },
  {
    q: "Do I need to create an account to use MentorX4u?",
    a: "Yes, creating an account allows you to access personalized features, track your progress, and receive tailored recommendations. Registration is quick and easy!"
  },
  {
    q: "Can I delete my MentorX4u account?",
    a: "Yes, you can delete your account at any time. Simply go to your account settings and follow the instructions to delete your account permanently."
  },
  {
    q: "What types of services does MentorX4u offer?",
    a: "MentorX4u offers a range of services, including personalized counseling, career assessments, educational resources, and AI-driven insights to help you make informed decisions about your education and career."
  },
  {
    q: "How does MentorX4u use cookies?",
    a: "We use cookies to enhance your experience on our website. Cookies help us understand user preferences, improve our services, and deliver personalized content. You can manage your cookie preferences through your browser settings."
  },
  {
    q: "How can I report suspicious activity on MentorX4u?",
    a: "If you notice any suspicious behavior or have concerns about your safety while using MentorX4u, please report it to our support team at [support@MentorX4u.com]. Your safety is our priority, and we take such matters seriously."
  },
  {
    q: "Is there a fee for using MentorX4u?",
    a: "MentorX4u offers various services, some of which may be free while others may require a subscription or payment. Please refer to our pricing page for detailed information about the services and associated costs."
  },
  {
    q: "How can I contact MentorX4u support?",
    a: "You can reach our support team via email at [support@MentorX4u.com]. We are here to assist you with any questions or concerns you may have."
  },
  {
    q: "Where can I find more information about MentorX4u?",
    a: "For more information about our services, features, and updates, please explore our website or follow us on our social media channels."
  }
];
